import { ElMessageBox } from "element-plus";
import { ElMessageBoxOptions, Action } from "element-plus/es/components/message-box";

interface Message {
  confirm(message: string, config?: ElMessageBoxOptions): Promise<boolean>;
  prompt(message: string, config?: ElMessageBoxOptions): Promise<boolean>;
  alert(message: string, config?: ElMessageBoxOptions): Promise<unknown>;
}

export default function useMessages(): Message {
  const defaultTitle = "Are you sure?";

  const parseTitle = (config?: ElMessageBoxOptions) => {
    const configTitle = (config || {}).title || "";
    return configTitle == null ? defaultTitle : configTitle;
  };

  const confirm = async (message: string, config?: ElMessageBoxOptions) => {
    try {
      await ElMessageBox.confirm(message, parseTitle(config), config);
      return true;
    } catch {
      return false;
    }
  };

  const prompt = async (message: string, config?: ElMessageBoxOptions) => {
    try {
      await ElMessageBox.prompt(message, parseTitle(config), config);
      return true;
    } catch {
      return false;
    }
  };

  const alert = async (message: string, config?: ElMessageBoxOptions) =>
    // eslint-disable-next-line implicit-arrow-linebreak
    new Promise((resolve) => {
      ElMessageBox.alert(message, parseTitle(config), {
        ...config,
        callback(action: Action) {
          resolve(action === "confirm");
        },
      });
    });

  return {
    confirm,
    prompt,
    alert,
  };
}
